import { documentHasElements } from "modules/dom";
import "./faq-page.scss";

documentHasElements(".js-faq-page", () => {

    const faqPage = {
        init: function () {
            faqPage.addLinkList();
            faqPage.wrapAccordions();
            faqPage.addSmoothScroll();
        },

        addLinkList: () => {
            const blocks = document.querySelectorAll(".faq-blocks > .accordion-block");
            const tabs = document.querySelector(".faq-list");

            blocks.forEach((block) => {
                const listItem = document.createElement("li");
                const listLink = document.createElement("a");
                const blockId = block.getAttribute("id");

                if (blockId !== null) {
                    listLink.innerHTML = blockId.toString();
                    listLink.setAttribute("href", "#" + blockId.toString());
                    listItem.appendChild(listLink);
                }

                if (listItem && tabs) {
                    tabs.appendChild(listItem);
                }
            });
        },
        wrapAccordions: () => {
            const blocks = document.querySelectorAll(".faq-blocks > .accordion-block");

            blocks.forEach((block, i) => {
                if (i % 2 === 0) { 
                    const wrapper = document.createElement("div");
                    wrapper.classList.add("accordion-block__dark");

                    if (block.parentNode !== null) {
                        block.parentNode.insertBefore(wrapper, block);
                        wrapper.appendChild(block);
                    }
                }
            });       
        },
        addSmoothScroll: () => {
            const html = document.querySelector("html");

            if (html) {
                html.classList.add("html-scroll__smooth");
            }
        },
    };

    faqPage.init();

});